<ng-container *transloco="let t; read: 'basket'">

  @if (!offline) {
    <button
      kendoButton
      [disabled]="(currentCompany?.tenantId == null) && isAdminView"
      class="buttonPrimary offlineBasketSync"
      (click)="onSyncOffline()">
      {{t('syncOfflineBasket')}}
    </button>
  }

  <!-- DESKTOP GRID -->
  <kendo-grid
    [data]="offlineBasketItems"
    (remove)="removeOfflineHandler($event)">
    <kendo-grid-column
      field="internalNumber"
      [title]="t('procutInternalNumber')"
      media="(min-width: 993px)">
    </kendo-grid-column>

    <kendo-grid-column
      field="quantity"
      [title]="t('basketQuantity')"
      media="(min-width: 993px)">
    </kendo-grid-column>

    <!-- MOBILE GRID -->
    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('procutInternalNumber')}}</h4>
        <span>{{dataItem.internalNumber}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('basketQuantity')}}</h4>
        <span>{{dataItem.quantity}}</span>
      </ng-template>
    </kendo-grid-column>

    <!-- COMMAND COLUMN -->
    <kendo-grid-command-column>
      <ng-template kendoGridCellTemplate>
        <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
</ng-container>